import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Two-column responsive layout for `DetailField`s, as a description list.
 *
 * Rendering `<dl>` keeps the label/value pairs semantically linked, which a
 * grid of disabled text inputs never was.
 */
export default function DetailGrid({ children, columns }) {
  return (
    <Box
      component="dl"
      sx={{
        m: 0,
        p: 3,
        display: 'grid',
        rowGap: 2,
        columnGap: 2,
        gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: `repeat(${columns}, 1fr)` },
      }}
    >
      {children}
    </Box>
  );
}

DetailGrid.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
};

DetailGrid.defaultProps = {
  children: null,
  columns: 2,
};
